import axios from 'axios';
import { IFaqResponse } from 'types/services';
import { Apis } from 'constants/apis';
import { getToken } from 'utils/token';

const allFaqs = async (featured?: boolean): Promise<IFaqResponse[]> => {
    const { data } = await axios.get(`${Apis.GET_FAQS}${featured? '?featured=1': ''}`, { headers: { Authorization: getToken() } });
    return data;
};

export default allFaqs;
